import pii from './pii';

const root = {
	pii
};

export default root;
